import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Signal,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DropdownComponent } from '@appkit4/angular-components/dropdown';
import { ComboboxItemFilter } from '@shared/abstraction/combobox/combobox-item-filter';
import { BaseDropdownComboboxComponent } from '../base-components/base-dropdown-combobox';

@Component({
  standalone: false,
  selector: 'gstar-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFilterComponent
  extends BaseDropdownComboboxComponent
  implements OnInit
{
  dropdown: Signal<DropdownComponent | undefined> =
    viewChild<DropdownComponent>('dropdown');

  constructor() {
    super();

    this.optionsSettingResolver = this.resolver;

    this.clearAll.pipe(takeUntilDestroyed()).subscribe(() => {
      const currentValue = this.value();
      if (currentValue) {
        this.clearValue(currentValue);
      }

      const dropdown = this.dropdown();
      if (dropdown?.dropdownListRef?.nativeElement) {
        dropdown.dropdownListRef.nativeElement.scrollTo(0, 0);
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  closeHandler(): void {
    if (this.selectedItems.length === 0) {
      const dropdown = this.dropdown();
      if (dropdown?.dropdownListRef?.nativeElement) {
        this.dropdown()!.dropdownListRef.nativeElement.scrollTo(0, 0);
      }
    }
  }

  private resolver(options: ComboboxItemFilter[]): void {
    this.options.set(options);
  }
}
